import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Radio, FormGroup, ControlLabel } from 'react-bootstrap';
import _ from 'underscore';
import GoogleMapReact from 'google-map-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  Button,
} from '@cargomatic/ui';

export default class DuplicateLocationModal extends Component {
  static propTypes = {
    addresses: PropTypes.array.isRequired,
    onSelectLocation: PropTypes.func.isRequired,
    show: PropTypes.func,
    onHide: PropTypes.func,
  };

  constructor(props) {
    super(props);
    const address = _.first(props.addresses);
    this.state = {
      selectedAddress: address.coords,
      zoom: 10,
      center: {
        lat: address.lat,
        lng: address.lng,
      },
    };
  }

  handleMapChange = ({ /* center, bounds, marginBounds, */ size, zoom }) => {
    if (this.state.size !== size) this.setState({ size });
    this.setState({ zoom });
  };

  handleSubmit = () => {
    const duplicateAddress = this.props.addresses.filter((location) => {
      return location.coords === this.state.selectedAddress;
    });
    this.props.onSelectLocation(_.first(duplicateAddress));
  };

  handleLocationSelect = (coords) => {
    this.setState({ selectedAddress: coords });
  };

  render() {
    const { addresses } = this.props;
    if (!addresses) {
      return null;
    }

    const Marker = ({ text }) => {
      return (
        <div style={{ width: 20, height: 20 }}>
          <i
            className="icon-location marker"
            style={{ color: '#21b88e', fontSize: '24px' }}
          />
          <div
            style={{
              marginLeft: '9px',
              color: 'black',
              borderRadius: '50%',
              fontSize: '14px',
              paddingLeft: '4px',
            }}
          >
            {text}
          </div>
        </div>
      );
    };

    const markers = addresses.map((address, index) => {
      return (
        <Marker
          lat={address.lat}
          lng={address.lng}
          key={index}
          text={index + 1}
        />
      );
    });

    const locationRadioButtons = (
      <FormGroup controlId="location_select">
        <ControlLabel>Select an Address</ControlLabel>
        {addresses.map((add, index) => {
          const number = index + 1;
          return (
            <Radio
              key={add.coords}
              name="location_select"
              value={add.coords}
              checked={
                this.state.selectedAddress &&
                this.state.selectedAddress === add.coords
              }
              onChange={() => this.handleLocationSelect(add.coords)}
            >
              {`${number}. ${add.lat}, ${add.lng}`}
            </Radio>
          );
        })}
      </FormGroup>
    );

    return (
      <Dialog
        open={this.props.show}
        onOpenChange={this.props.onHide}
        className="z-[999999]"
      >
        <DialogContent className="sm:max-w-[1080px]">
          <DialogHeader>
            <DialogTitle>{`Select Address - ${addresses[0].address}`}</DialogTitle>
          </DialogHeader>
          <div className="flex" style={{ height: '400px', width: '880px' }}>
            <div className="col-md-6">
              <p>
                Multiple Locations were found with this address. Please select
                the correct one.
              </p>
              <div>{locationRadioButtons}</div>
            </div>
            <div className="col-md-6">
              <div style={{ width: 400, height: 300 }}>
                {markers && (
                  <GoogleMapReact
                    bootstrapURLKeys={{
                      key: GOOGLE_MAPS_KEY,
                      language: 'en',
                    }}
                    defaultCenter={this.state.center}
                    defaultZoom={this.state.zoom}
                  >
                    {markers}
                  </GoogleMapReact>
                )}
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button
              variant="outline"
              onClick={this.props.onHide}
              className="mr-2"
            >
              Cancel
            </Button>
            <Button
              onClick={this.handleSubmit}
              disabled={!this.state.selectedAddress}
              style={{ background: '#21b88e' }}
            >
              Submit
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
}
